import { useDispatch, useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';
import { layoutActions } from '../redux/slices/layout';

export function useEnableSpeedyRX() {
  const dispatch = useDispatch();
  const enableSpeedyRXCookie = getCookieByName('speedyExperience', true);

  const enableSpeedyRXFlow = useSelector(
    (state: any) => state.workflow.flowDefiningAttributes?.enableSpeedyRX
  );
  const speedyRXConfig = useSelector(
    (state: any) => state.config.speedyRxModule
  );

  let speedyExperience: boolean | undefined;

  // Assegna il valore a speedyExperience solo una volta
  if (enableSpeedyRXCookie !== null && enableSpeedyRXCookie !== undefined) {
    speedyExperience = enableSpeedyRXCookie as boolean;
  } else if (
    speedyRXConfig?.speedyExperience !== null &&
    speedyRXConfig?.speedyExperience !== undefined
  ) {
    speedyExperience = speedyRXConfig.speedyExperience;
  } else if (enableSpeedyRXFlow !== null && enableSpeedyRXFlow !== undefined) {
    speedyExperience = enableSpeedyRXFlow;
  }

  // Se `speedyExperience` è definito, esegui il dispatch
  if (speedyExperience !== undefined) {
    dispatch(
      layoutActions.setSpeedyRXActive({
        speedyExperience: speedyExperience,
        isFirstSetup: true,
        isActive: !!(speedyRXConfig?.isActive() && speedyExperience),
      })
    );
  }

  return;
}
